// @ts-nocheck

(function () {
  const LOG = (...args) => console.log('[MeasuraSwap]', ...args);

  const STATE = {
    hasDiscount: false,
    mo: null,
    syncTimer: null,
    syncDeadline: 0,
    syncStartedAt: 0,
    syncStableTicks: 0,
    suppress: false,
    unitOriginalStored: false,
  };

  const now = () => new Date().toISOString().split('T')[1].replace('Z', '');

  function getOrCreateOriginalUnitStash(nextToEl) {
    let stash = nextToEl?.parentElement?.querySelector('[data-measura-original-unit="true"]');
    if (stash) return stash;

    stash = document.createElement('div');
    stash.setAttribute('data-measura-original-unit', 'true');
    stash.style.display = 'none';

    try {
      nextToEl.insertAdjacentElement('afterend', stash);
    } catch {
      nextToEl.parentElement?.appendChild(stash);
    }

    return stash;
  }

  function findLastMoneyMatch(text) {
    if (!text) return null;

    const str = String(text);
    const pattern = /-?\d{1,3}(?:[.\s]\d{3})*(?:[.,]\d{2})|-?\d+(?:[.,]\d{2})/g;
    let match;
    let last = null;

    while ((match = pattern.exec(str)) !== null) {
      last = { raw: match[0], start: match.index, end: match.index + match[0].length };
    }

    if (!last) return null;

    const normalized = last.raw.replace(/\s/g, '').replace(/\./g, '').replace(',', '.');
    const value = parseFloat(normalized);
    if (!Number.isFinite(value)) return null;

    return { ...last, value };
  }

  function formatMoneyWithGrouping(value, rawPattern = '') {
    const fixed = Number(value).toFixed(2);
    const [intPart, decPart] = fixed.split('.');
    let groupSep = '';

    if (rawPattern.includes(' ')) groupSep = ' ';
    else if (rawPattern.includes('.')) groupSep = '.';

    const intWithGroups = groupSep ? intPart.replace(/\B(?=(\d{3})+(?!\d))/g, groupSep) : intPart;
    return intWithGroups + ',' + decPart;
  }

  function replaceRange(text, start, end, replacement) {
    return text.slice(0, start) + replacement + text.slice(end);
  }

  function findPriceElement(selector, root = document) {
    return (
      Array.from(root.querySelectorAll(selector)).find((el) => {
        return (
          el &&
          !['SCRIPT', 'TEMPLATE', 'NOSCRIPT'].includes(el.tagName) &&
          !el.classList.contains('measura-block-script')
        );
      }) || null
    );
  }

  function findFirstMatchingElement(selectors, root = document) {
    for (const selector of selectors) {
      const match = findPriceElement(selector, root);
      if (match) return match;
    }

    return null;
  }

  function extractMeasurementSuffix(text) {
    const normalized = String(text || '').trim();
    const slashIndex = normalized.indexOf('/');
    if (slashIndex === -1) return '';
    return normalized.slice(slashIndex).trim();
  }

  function findOriginalUnitPrice(root = document) {
    return (
      Array.from(
        root.querySelectorAll(
          '.measura-unit-price, .original-price[data-price], .original-price, [data-price]:not(.discounted-price)'
        )
      ).find((el) => {
        return (
          el &&
          !['SCRIPT', 'TEMPLATE', 'NOSCRIPT'].includes(el.tagName) &&
          !el.classList.contains('measura-block-script') &&
          !el.hasAttribute('data-measura-mirror-unit')
        );
      }) || null
    );
  }

  function getOrCreateMirrorUnitPrice(unitPrice) {
    let mirror = unitPrice?.parentElement?.querySelector('[data-measura-mirror-unit="true"]');
    if (!mirror) {
      mirror = document.createElement(unitPrice?.tagName?.toLowerCase() || 'span');
      mirror.setAttribute('data-measura-mirror-unit', 'true');

      try {
        unitPrice.insertAdjacentElement('afterend', mirror);
      } catch {
        unitPrice.parentElement?.appendChild(mirror);
      }
    }

    mirror.className = 'measura-mirror-unit-price';
    mirror.removeAttribute('data-price');
    mirror.removeAttribute('data-price-wrapper');
    mirror.style.display = '';
    mirror.style.textDecoration = unitPrice.style.textDecoration || '';
    mirror.style.color = unitPrice.style.color || '';
    mirror.style.fontSize = unitPrice.style.fontSize || '';
    mirror.style.fontWeight = unitPrice.style.fontWeight || '';
    mirror.style.lineHeight = unitPrice.style.lineHeight || '';

    return mirror;
  }

  function getMirrorValueNode(mirror) {
    if (!mirror.shadowRoot) {
      const shadowRoot = mirror.attachShadow({ mode: 'open' });
      const valueNode = document.createElement('span');
      valueNode.setAttribute('data-measura-mirror-value', 'true');
      shadowRoot.appendChild(valueNode);
      return valueNode;
    }

    let valueNode = mirror.shadowRoot.querySelector('[data-measura-mirror-value="true"]');
    if (!valueNode) {
      valueNode = document.createElement('span');
      valueNode.setAttribute('data-measura-mirror-value', 'true');
      mirror.shadowRoot.appendChild(valueNode);
    }

    return valueNode;
  }

  function renderUnitPrice(unitPrice, totalText, measurementSuffix) {
    const nextTotal = String(totalText || '').trim();
    const nextSuffix = String(measurementSuffix || '').trim();
    const valueNode = getMirrorValueNode(unitPrice);
    const currentVisibleText = String(valueNode.textContent || '').trim();

    if (
      currentVisibleText === nextTotal &&
      unitPrice.dataset.measuraRenderedTotal === nextTotal &&
      unitPrice.dataset.measuraRenderedSuffix === nextSuffix
    ) {
      return false;
    }

    valueNode.textContent = nextTotal;
    if (unitPrice.childNodes.length) {
      unitPrice.textContent = '';
    }

    unitPrice.dataset.measuraRenderedTotal = nextTotal;
    unitPrice.dataset.measuraRenderedSuffix = nextSuffix;
    return true;
  }

  function scheduleSync(reason, duration = 1400, interval = 120) {
    const nextDeadline = Date.now() + duration;
    STATE.syncDeadline = Math.max(STATE.syncDeadline, nextDeadline);
    STATE.syncStableTicks = 0;

    if (STATE.syncTimer) {
      LOG(now(), `sync extended (${reason})`);
      return;
    }

    STATE.syncStartedAt = Date.now();
    LOG(now(), `sync scheduled (${reason})`);

    const tick = () => {
      const changed = runMirror();
      STATE.syncStableTicks = changed ? 0 : STATE.syncStableTicks + 1;

      const elapsed = Date.now() - STATE.syncStartedAt;
      const stableEnough = elapsed >= 480 && STATE.syncStableTicks >= 3;

      if (Date.now() < STATE.syncDeadline && !stableEnough) {
        STATE.syncTimer = setTimeout(tick, interval);
        return;
      }

      STATE.syncTimer = null;
      STATE.syncDeadline = 0;
      STATE.syncStartedAt = 0;
      STATE.syncStableTicks = 0;
      LOG(now(), stableEnough ? 'sync complete (stable)' : 'sync complete');
    };

    STATE.syncTimer = setTimeout(tick, 0);
  }

  function recalcDiscount(ctx) {
    const discEl = ctx.container.querySelector('.discounted-price');
    if (!discEl) return false;

    let changed = false;
    const pctStr = discEl.getAttribute('data-discount-percentage') || discEl.dataset.discountPercentage;
    let pct = parseFloat(String(pctStr).replace(',', '.'));
    if (!Number.isFinite(pct)) return false;

    let currentWeight = null;
    const selectedPill = ctx.container.querySelector('.measura-pill input[type="radio"]:checked');
    if (selectedPill) {
      const val = selectedPill.value || selectedPill.getAttribute('data-weight');
      if (val) {
        const match = String(val).match(/(\d+)(g)?/);
        if (match) currentWeight = parseInt(match[1], 10);
      }
    }

    let maxTierDiscount = 0;
    if (currentWeight) {
      for (let i = 1; i <= 4; i += 1) {
        const tierAttr = discEl.getAttribute(`data-measura-t${i}`);
        if (!tierAttr) continue;

        const [tierWeightStr, tierDiscountStr] = tierAttr.split(':');
        const tierWeight = parseInt(tierWeightStr, 10);
        const tierDiscount = parseFloat(tierDiscountStr);
        if (currentWeight >= tierWeight && tierDiscount > maxTierDiscount) {
          maxTierDiscount = tierDiscount;
        }
      }

      if (maxTierDiscount > pct) {
        pct = maxTierDiscount;
      }
    }

    if (pct <= 0) {
      if (discEl.style.display !== 'none') {
        discEl.style.display = 'none';
        changed = true;
      }

      if (ctx.price.style.textDecoration !== 'none') {
        ctx.price.style.textDecoration = 'none';
        changed = true;
      }
    } else {
      if (discEl.style.display === 'none') {
        discEl.style.display = '';
        changed = true;
      }

      if (ctx.price.style.textDecoration !== 'line-through') {
        ctx.price.style.textDecoration = 'line-through';
        changed = true;
      }

      if (discEl.classList.contains('measura-unit-price')) {
        discEl.classList.remove('measura-unit-price');
        changed = true;

        const discText = discEl.textContent || '';
        const unitSuffixIndex = discText.indexOf('/');
        if (unitSuffixIndex !== -1) {
          discEl.textContent = discText.slice(0, unitSuffixIndex).trim();
          changed = true;
        }
      }

      const totalMatch = findLastMoneyMatch(ctx.totalPrice.textContent);
      if (!totalMatch) return changed;

      const discounted = totalMatch.value * (1 - pct / 100);
      const discMatch = findLastMoneyMatch(discEl.textContent);
      const rawPattern = discMatch ? discMatch.raw : totalMatch.raw;
      const formatted = formatMoneyWithGrouping(discounted, rawPattern);
      const nextDiscountText = discMatch
        ? replaceRange(discEl.textContent, discMatch.start, discMatch.end, formatted)
        : (discEl.textContent || '') + ' ' + formatted;

      if (discEl.textContent !== nextDiscountText) {
        discEl.textContent = nextDiscountText;
        changed = true;
      }

      const nextDiscountedPrice = String(discounted);
      if (discEl.dataset.discountedPrice !== nextDiscountedPrice) {
        discEl.dataset.discountedPrice = nextDiscountedPrice;
        changed = true;
      }

      if (changed) {
        LOG(now(), `discount recalculated (${pct}%):`, discEl.textContent);
      }
    }

    return changed;
  }

  document.addEventListener('change', (e) => {
    if (e.target && e.target.matches('.measura-pill input[type="radio"]')) {
      LOG(now(), 'pill change → schedule sync');
      scheduleSync('pill change');
    }
  });

  document.addEventListener(
    'variantChange',
    (e) => {
      LOG(now(), 'variantChange', e?.detail || '');
      scheduleSync('variant change');
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => {
    LOG(now(), 'DOMContentLoaded');
    let tries = 0;

    (function tick() {
      LOG(now(), `boot try #${tries + 1}`);
      if (wireObserver()) {
        LOG(now(), 'sync armed → initial resync');
        scheduleSync('initial boot', 1800, 140);
        return;
      }

      tries += 1;
      if (tries < 30) setTimeout(tick, 120);
    })();
  });

  function findCtx() {
    const price = findFirstMatchingElement([
      '[data-measura-mirror-unit="true"]',
      '.original-price[data-price]',
      '.original-price',
      '.price',
    ]);

    if (!price) {
      LOG(now(), 'findCtx: no .price/.original-price');
      return null;
    }

    const totalPrice = findPriceElement('.measura-total-price');
    const priceContainer =
      price.closest('.price-wrapper, .price-container, .product__info-container, .product, main') || document;
    const unitPrice = findOriginalUnitPrice(priceContainer);
    if (!totalPrice || !unitPrice) {
      LOG(now(), 'findCtx: missing total/unit price', { total: !!totalPrice, unit: !!unitPrice });
      return null;
    }

    const displayPrice = findPriceElement('[data-measura-mirror-unit="true"]', priceContainer) || unitPrice;
    const container =
      totalPrice.closest('.product__info-container') || totalPrice.closest('.product, main') || document.body;

    LOG(now(), 'findCtx: ok', { containerTag: container.tagName || 'BODY' });
    return { price: displayPrice, totalPrice, unitPrice, container, priceContainer };
  }

  function wireObserver() {
    if (STATE.mo) {
      LOG(now(), 'sync already armed');
      return true;
    }

    const ctx = findCtx();
    if (!ctx) {
      LOG(now(), 'wireObserver: ctx not ready');
      return false;
    }

    STATE.mo = { active: true };
    LOG(now(), 'sync armed on', ctx.priceContainer);
    return true;
  }

  function runMirror() {
    const ctx = findCtx();
    if (!ctx) {
      LOG(now(), 'runMirror: ctx not ready');
      return false;
    }

    const totalText = (ctx.totalPrice.textContent || '').trim();
    const unitText = (ctx.unitPrice.textContent || '').trim();

    LOG(now(), 'runMirror: texts', { total: totalText, unit: unitText });

    if (!totalText) {
      LOG(now(), 'runMirror: empty totalText → skip');
      return false;
    }

    LOG(now(), 'MIRROR total → unit, hide total + recalc discount');

    try {
      STATE.suppress = true;

      const stash = getOrCreateOriginalUnitStash(ctx.totalPrice);
      let changed = false;

      if (!STATE.unitOriginalStored && unitText) {
        stash.textContent = ctx.unitPrice.textContent;
        STATE.unitOriginalStored = true;
        changed = true;
        LOG(now(), 'stored original unit price once');
      }

      if (ctx.totalPrice.style.display !== 'none') {
        ctx.totalPrice.style.display = 'none';
        changed = true;
        LOG(now(), 'total price hidden');
      }

      const mirrorPrice = getOrCreateMirrorUnitPrice(ctx.unitPrice);

      if (ctx.unitPrice.style.display !== 'none') {
        ctx.unitPrice.style.display = 'none';
        changed = true;
        LOG(now(), 'original unit price hidden');
      }

      if (!stash.textContent && unitText) {
        stash.textContent = unitText;
        changed = true;
      }

      const measurementSuffix = extractMeasurementSuffix(stash.textContent || unitText);
      if (renderUnitPrice(mirrorPrice, totalText, measurementSuffix)) {
        changed = true;
        LOG(now(), 'mirror price updated');
      }

      if (recalcDiscount(ctx)) {
        changed = true;
      }

      return changed;
    } finally {
      setTimeout(() => {
        STATE.suppress = false;
        LOG(now(), 'unsuppress observer');
      }, 0);
    }
  }
})();
